import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../utils/firebase";
import { doc, getDoc } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import logo from "../assets/imgs/logo-yellow.png";
import "../styles/navbar.css";

export default function Navbar() {
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const [name, setName] = useState("LOGIN");
  // Default options
  const [options, setOptions] = useState(
    <div className="dropdown text-end">
      <button
        className="btn dropdown-toggle sub-menu-item btn-warning"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{ marginRight: 20 }}
      >
        <i className="bi bi-person-fill"></i>
      </button>
      <ul className="dropdown-menu">
        <li>
          <a className="dropdown-item" type="button" href="/Login">
            LOGIN
          </a>
        </li>

        <li>
          <a
            className="dropdown-item"
            type="button"
            onClick={() => {
              auth.signOut();
              navigate("/");
            }}
          >
            LOGOUT
          </a>
        </li>
      </ul>
    </div>
  );

  useEffect(() => {
    if (user) {
      async function getUser() {
        const docRef = doc(db, "Users", user.uid);
        const result = await getDoc(docRef);
        if (result.data().userTypeNumber == 4) {
          setOptions(
            <ul className="dropdown-menu">
              <li>
                <Link className="dropdown-item" type="button" to="/Dashboard">
                  My Dashboard
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item"
                  type="button"
                  to="/CreateProposal"
                >
                  Create Proposal
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item"
                  type="button"
                  to="/CreateCommunity"
                >
                  Create Community
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item"
                  type="button"
                  to="/"
                  onClick={() => {
                    localStorage.clear();
                    auth.signOut();
                    navigate("/");
                  }}
                >
                  LOGOUT
                </Link>
              </li>
            </ul>
          );
        } else if (result.data().userTypeNumber == 3) {
          setOptions(
            <div className="dropdown text-end">
              <button
                className="btn dropdown-toggle sub-menu-item btn-warning"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ marginRight: 20 }}
              >
                <i className="bi bi-person-fill"></i>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" type="button" to="/Dashboard">
                    My Dashboard
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    type="button"
                    to={`${result.data().communitySlug}`}
                  >
                    My Community
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    type="button"
                    to="/CreateProposal"
                  >
                    Create Proposal
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    type="button"
                    to="/"
                    onClick={() => {
                      localStorage.clear();
                      auth.signOut();
                      navigate("/");
                    }}
                  >
                    LOGOUT
                  </Link>
                </li>
              </ul>
            </div>
          );
        } else if (result.data().userTypeNumber == 2) {
          setOptions(
            <div className="dropdown text-end">
              <button
                className="btn dropdown-toggle sub-menu-item btn-warning"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ marginRight: 20 }}
              >
                <i className="bi bi-person-fill"></i>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" type="button" to="/Dashboard">
                    My Dashboard
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    type="button"
                    to={`${result.data().communitySlug}`}
                  >
                    My Community
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    type="button"
                    to="/CreateProposal"
                  >
                    Create Proposal
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    type="button"
                    to="/"
                    onClick={() => {
                      localStorage.clear();
                      auth.signOut();
                      navigate("/");
                    }}
                  >
                    LOGOUT
                  </Link>
                </li>
              </ul>
            </div>
          );
        } else if (result.data().userTypeNumber == 1) {
          setOptions(
            <div className="dropdown text-end">
              <button
                className="btn dropdown-toggle sub-menu-item btn-warning"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ marginRight: 20 }}
              >
                <i className="bi bi-person-fill"></i>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" type="button" to="/Dashboard">
                    My Dashboard
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    type="button"
                    to="/"
                    onClick={() => {
                      auth.signOut();
                      localStorage.clear();
                      navigate("/");
                    }}
                  >
                    LOGOUT
                  </Link>
                </li>
              </ul>
            </div>
          );
        }

        setName(result.data().firstName);
      }

      getUser();
    } else if (!user) {
      setOptions(
        <Link className="btn btn-warning px-4 fw-bold fs-6" to="/Login">
          LOGIN
        </Link>
      );
    }
  }, [user]);

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary">
      <div className="container">
        <Link className="logo" to="/">
          <img src={logo} height={82} alt="" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Mobile Menu */}
        <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link
                className="nav-link px-4 fs-6 hover:text-red-700 !important"
                to="/"
              >
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link px-4--- fs-6--" to="/Communities">
                All Communities
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link px-4-- fs-6--" to="/Contact">
                Contact Us
              </Link>
            </li>

            {user ? (
              ""
            ) : (
              <li className="nav-item">
                <Link className="nav-link px-4 fw-bold fs-6" to="/join">
                  Sign Up
                </Link>
              </li>
            )}
          </ul>
          {/* <div className="dropdown text-end">
            <button
              className="btn dropdown-toggle sub-menu-item btn-warning"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ marginRight: 20 }}
            >
              icon
            </button> */}
          {options}
          {/* </div> */}
        </div>
      </div>
    </nav>
  );
}
